import angular from 'angular'

const STORE_TYPES = {
  STANDALONE: 'standalone',
  MYRENAULT: 'myrenault',
  HELIOS: 'helios',
  ONE: 'one',
  RSITE: 'rsite'
}

let module = angular.module('storeTypes', [])

.constant('StoreTypes', STORE_TYPES)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/common/store-types/index.js